export default {"src":"/_next/static/media/desert.fe04b353.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};